import { Component } from '@angular/core';

import { VerkopenPage } from '../verkopen/verkopen';
import { QrscannerPage } from '../qrscanner/qrscanner';
import { StatusPage } from '../status/status';

@Component({
  templateUrl: 'tabs.html'
})
export class TabsPage {

  tab1Root = VerkopenPage;
  tab2Root = QrscannerPage;
  tab3Root = StatusPage;

  constructor() {

  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts